import { gql } from '@apollo/client'

export const CASE_EMAILS_QUERY = gql`
  query caseEmails(
    $caseId: ID!
    $direction: CaseEmailDirection
    $processingId: ID
    $includeVisibleForOtherProcessings: Boolean
  ) {
    caseEmails(
      caseId: $caseId
      direction: $direction
      processingId: $processingId
      includeVisibleForOtherProcessings: $includeVisibleForOtherProcessings
    ) {
      id
      direction
      status
      subject
      bodyHtml
      bodyText
      sanitizedBodyHtml
      fromAddress
      fromName
      toAddresses
      ccAddresses
      bccAddresses
      sentAt
      receivedAt
      readAt
      read
      hasAttachments
      senderUnverified
      visibleForOtherProcessings
      errorMessage
      createdAt
      attachments {
        url
        filename
        contentType
        signedId
      }
      user {
        id
        name
      }
      processing {
        id
      }
      parentEmail {
        id
        subject
        fromName
      }
    }
  }
`
